<section
  class="atw-page about-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <div class="atw-container">

    <!-- Hero -->
    <div class="about-hero">
      <div class="about-hero-content">
        <div class="hero-badge">
          <span>{{ 'atw.about.hero.badgeNumber' | transloco }}</span>
          {{ 'atw.about.hero.badgeTitle' | transloco }}
        </div>

        <h1>
          {{ 'atw.about.hero.titleLine1' | transloco }}
          <strong>{{ 'atw.about.hero.titleStrong' | transloco }}</strong>
        </h1>

        <p>
          {{ 'atw.about.hero.description' | transloco }}
        </p>

        <div class="hero-actions">
          <button class="primary-action" type="button" (click)="scrollToSection('about-journey')">
            {{ 'atw.about.hero.primaryBtn' | transloco }}
          </button>

          <button class="secondary-action" type="button" (click)="scrollToSection('about-services')">
            {{ 'atw.about.hero.secondaryBtn' | transloco }}
            <img class="img-m" src="assets/as/23.webp" alt="services" />
          </button>
        </div>
      </div>

      <div class="about-hero-visual">
        <div class="about-visual-card">
          <div class="about-visual-icon">
            <img class="img-xl" src="assets/as/1.webp" alt="global" />
          </div>

          <strong>{{ 'atw.about.hero.visualTitle' | transloco }}</strong>
          <p>{{ 'atw.about.hero.visualText' | transloco }}</p>

          <div class="about-visual-license">
            <span>{{ 'atw.about.hero.licenseLabel' | transloco }}</span>
            <b>{{ 'atw.about.hero.licenseValue' | transloco }}</b>
          </div>
        </div>

        <div class="floating-card about-floating-card">
          <img class="img-m" src="assets/as/27.webp" alt="verified" />

          <div>
            <strong>{{ 'atw.about.hero.floatTitle' | transloco }}</strong>
            <small>{{ 'atw.about.hero.floatText' | transloco }}</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Story -->
    <section class="apply-section" id="about-story">
      <div class="section-title">
        <span>
          <b>{{ 'atw.about.story.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.about.story.title' | transloco }}</h2>
          <p>{{ 'atw.about.story.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="apply-card about-story-card">
        <div class="about-story-content">
          <span>{{ 'atw.about.story.label' | transloco }}</span>

          <h3>{{ 'atw.about.story.heading' | transloco }}</h3>

          <p>{{ 'atw.about.story.paragraph1' | transloco }}</p>
          <p>{{ 'atw.about.story.paragraph2' | transloco }}</p>
        </div>

        <div class="about-story-side">
          <div class="about-side-item">
            <div>
              <img class="img-l" src="assets/as/9.webp" alt="company" />
            </div>

            <strong>{{ 'atw.about.story.side1Title' | transloco }}</strong>
            <p>{{ 'atw.about.story.side1Text' | transloco }}</p>
          </div>

          <div class="about-side-item">
            <div>
              <img class="img-l" src="assets/as/26.webp" alt="partners" />
            </div>

            <strong>{{ 'atw.about.story.side2Title' | transloco }}</strong>
            <p>{{ 'atw.about.story.side2Text' | transloco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Stats -->
    <section class="apply-section">
      <div class="about-stats-grid">
        <div
          class="apply-card about-stat-card"
          *ngFor="let stat of stats; trackBy: trackByIndex"
        >
          <div class="about-stat-icon">
            <img
              class="img-xl"
              [src]="stat.iconImg"
              [alt]="stat.labelKey | transloco"
            />
          </div>

          <strong>{{ stat.valueKey | transloco }}</strong>
          <span>{{ stat.labelKey | transloco }}</span>
          <p>{{ stat.textKey | transloco }}</p>
        </div>
      </div>
    </section>

    <!-- Vision + Values -->
    <section class="apply-section">
      <div class="section-title">
        <span>
          <b>{{ 'atw.about.vision.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.about.vision.title' | transloco }}</h2>
          <p>{{ 'atw.about.vision.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="about-vision-grid">
        <div class="apply-card about-vision-card">
          <div class="about-card-label">
            {{ 'atw.about.vision.label' | transloco }}
          </div>

          <h3>{{ 'atw.about.vision.heading' | transloco }}</h3>
          <p>{{ 'atw.about.vision.text' | transloco }}</p>
        </div>

        <div class="about-values-grid">
          <div
            class="apply-card about-value-card"
            *ngFor="let value of values; trackBy: trackByIndex"
          >
            <div>
              <img
                class="img-l"
                [src]="value.iconImg"
                [alt]="value.titleKey | transloco"
              />
            </div>

            <strong>{{ value.titleKey | transloco }}</strong>
            <p>{{ value.textKey | transloco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Services -->
    <section class="apply-section" id="about-services">
      <div class="section-title">
        <span>
          <b>{{ 'atw.about.services.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.about.services.title' | transloco }}</h2>
          <p>{{ 'atw.about.services.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="about-services-grid">
        <div
          class="apply-card about-service-card"
          *ngFor="let service of services; trackBy: trackByIndex"
        >
          <div class="about-service-icon">
            <img
              class="img-l"
              [src]="service.iconImg"
              [alt]="service.titleKey | transloco"
            />
          </div>

          <h3>{{ service.titleKey | transloco }}</h3>
          <p>{{ service.textKey | transloco }}</p>
        </div>
      </div>
    </section>

    <!-- Sectors -->
    <section class="apply-section">
      <div class="section-title">
        <span>
          <b>{{ 'atw.about.sectors.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.about.sectors.title' | transloco }}</h2>
          <p>{{ 'atw.about.sectors.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="apply-card about-sectors-card">
        <div
          class="about-sector-item"
          *ngFor="let sector of sectors; trackBy: trackByIndex"
        >
          <div class="about-sector-icon">
            <img
              class="img-l"
              [src]="sector.iconImg"
              [alt]="sector.titleKey | transloco"
            />
          </div>

          <div>
            <h3>{{ sector.titleKey | transloco }}</h3>
            <p>{{ sector.textKey | transloco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Journey -->
    <section class="apply-section" id="about-journey">
      <div class="section-title">
        <span>
          <b>{{ 'atw.about.journey.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.about.journey.title' | transloco }}</h2>
          <p>{{ 'atw.about.journey.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="about-journey-list">
        <div
          class="apply-card about-journey-step"
          *ngFor="let step of journeySteps; let i = index; trackBy: trackByIndex"
        >
          <div class="about-step-number">
            {{ i + 1 < 10 ? '0' + (i + 1) : i + 1 }}
          </div>

          <div>
            <h3>{{ step.titleKey | transloco }}</h3>
            <p>{{ step.textKey | transloco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Partners -->
    <section class="apply-section">
      <div class="section-title">
        <span>
          <b>{{ 'atw.about.partners.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.about.partners.title' | transloco }}</h2>
          <p>{{ 'atw.about.partners.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="apply-card about-partners-card">
        <span
          *ngFor="let partner of partners; trackBy: trackByIndex"
          class="about-partner-pill"
        >
          {{ partner.nameKey | transloco }}
        </span>
      </div>
    </section>

    <!-- CTA -->
    <section class="apply-section">
      <div class="apply-card about-cta">
        <div>
          <span>{{ 'atw.about.cta.badge' | transloco }}</span>
          <h2>{{ 'atw.about.cta.title' | transloco }}</h2>
          <p>{{ 'atw.about.cta.text' | transloco }}</p>
        </div>

        <a class="primary-action" routerLink="/jobs">
          {{ 'atw.about.cta.btn' | transloco }}
        </a>
      </div>
    </section>

  </div>
</section>
